import controller from './password-change.controller';
import template from './password-change.pug';

const LogoutComponent = {
  template,
  controller,
};

export default LogoutComponent;



// WEBPACK FOOTER //
// ./client/app/settings/password-change/password-change.component.js